import ee, { STORAGE_KEYS as s } from "../managers/storage-manager.js";
export function isDisabled() {
  return !!new ee.se(null, !0).pr(s.me);
}
